var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineChartUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.5 1.5a1 1 0 0 1 1 1v13.667l.002.331h.038c.08.002.174.002.293.002H17.5a1 1 0 1 1 0 2H3.804c-.208 0-.419 0-.6-.015a1.9 1.9 0 0 1-.703-.185 1.83 1.83 0 0 1-.801-.8 1.9 1.9 0 0 1-.185-.704c-.015-.18-.015-.391-.015-.599V2.5a1 1 0 0 1 1-1m11.667 5.333a1 1 0 1 1 0-2H17.5a1 1 0 0 1 1 1v3.334a1 1 0 1 1-2 0v-.92l-2.822 2.822-.014.015c-.07.069-.158.157-.243.23-.1.085-.26.205-.483.277a1.4 1.4 0 0 1-.876 0 1.4 1.4 0 0 1-.483-.277 4 4 0 0 1-.243-.23l-.014-.015L10 9.748l-3.46 3.46a1 1 0 0 1-1.414-1.415l3.696-3.695.014-.015c.07-.07.158-.158.243-.23.1-.085.26-.205.483-.278.285-.092.591-.092.876 0 .223.073.383.193.483.278.085.072.174.16.243.23l.014.015L12.5 9.419l2.586-2.586z",
  clipRule: "evenodd"
})));
SvgLineChartUp.displayName = "SvgLineChartUp";
export { SvgLineChartUp as ReactComponent };
export default SvgLineChartUp;